export default __webpack_public_path__ + "static/media/45year.48dbacf1.svg";